import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthRoutes } from 'src/app/utilities/routes';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
  })
  export class ResetPaswordComponent implements OnInit {

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private notification: NzNotificationService
        ) {
        this.resetPasswordForm = this.fb.group({
            confirmPassword: ['', Validators.required],
            newPassword: ['', Validators.required]
        });
      }

    resetPasswordForm: UntypedFormGroup;
    showResetForm = true;
    // showSuccessMessage = false;
    token: string;
    loadingBtn = false;
    regexString = /[a-zA-Z]/;
    regexNumber = /\d/;
    doesItHaveLetter = null;
    doesItHaveNumber = null;
    doesItHaveLength = null;
    pageLoader = true;
    arrayOfImgUrls = [
      'assets/slider/slider-1@2x.jpg',
      'assets/slider/slider-2@2x.jpg',
      'assets/slider/slider-3@2x.jpg',
      'assets/slider/slider-4@2x.jpg',

    ];
    ngOnInit() {
      this.token = this.activatedRoute.snapshot.params.token;
      this.tokenValidate();
      this.resetPasswordForm.controls.newPassword.valueChanges.subscribe((password: any) => {
        this.doesItHaveLetter = this.regexString.test(password);
        this.doesItHaveNumber = this.regexNumber.test(password);
        if (password.length >= 8) {
          this.doesItHaveLength = true;
        } else {
          this.doesItHaveLength = false;
        }
      });

    }
    resetPassword() {
      this.loadingBtn = true;
      if (this.resetPasswordForm.valid) {
        if (this.doesItHaveLetter && this.doesItHaveNumber && this.doesItHaveLength) {
          if (this.resetPasswordForm.value.confirmPassword === this.resetPasswordForm.value.newPassword) {
            const dataObject = {
              token: this.token,
              password: this.resetPasswordForm.value.confirmPassword,
            };
            this.authService.resetPassword(dataObject).subscribe((response: any) => {
              this.loadingBtn = false;
              this.notification.success(response.message, '', {
                nzKey : 'key'
              });
              // this.showResetForm = false; // Hide the reset form
              // // this.showSuccessMessage = true; // Show the Success Message in card
              this.goToLogin();
            }, () => {
              this.loadingBtn = false;
            });
          } else {
            this.loadingBtn = false;
            // Throw Error if new password and confirm password are not same
            this.notification.error(
            'New Password and Confirm password should be same', '', {
            nzKey: 'key'
          });
          }
        } else {
          this.loadingBtn = false;
          this.notification.error(
            'Password must contain Min 8 characters,1 letter,1 number ', '', {
            nzKey: 'key'
          });

        }
         } else {
          this.loadingBtn = false;
            // tslint:disable-next-line: forin
          for (const i in this.resetPasswordForm.controls) {
                this.resetPasswordForm.controls[i].markAsDirty();
                this.resetPasswordForm.controls[i].updateValueAndValidity();

            }
         }
    }
    tokenValidate() {
      this.pageLoader = true;
      const data = {
        token: this.token,
      };
      this.authService.validateToken(data).subscribe((response: any) => {
        this.pageLoader = false;
        if (response.data && response.data.isExpired === true) {
          this.router.navigate([AuthRoutes.linkExpired]);
        }else{
          this.pageLoader = false;
        }
      }, () => {
        this.router.navigate([AuthRoutes.linkExpired]);
        this.pageLoader = false;
      });
    }
    goToLogin() {
      this.router.navigate([AuthRoutes.login]);
    }
  }
